/**
 * File generated by js-routes 2.1.2
 * Based on Rails 7.2.3 routes of Reader::Application
 */
const __jsr = ((that) => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const Root = that;
    const isBroswer = typeof window !== "undefined";
    const ModuleReferences = {
        CJS: {
            define(routes) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                module.exports = routes;
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                define([], function () {
                    return routes;
                });
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define(routes) {
                Utils.namespace(Root, null, routes);
            },
            isSupported() {
                return !!Root;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const UriEncoderSegmentRegex = /[^a-zA-Z0-9\-._~!$&'()*+,;=:@]/g;
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (this.is_nullable(value)) {
                return "";
            }
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (this.is_nullable(prop) && prefix) {
                        prop = "";
                    }
                    if (this.is_not_nullable(prop)) {
                        if (prefix) {
                            key = prefix + "[" + key + "]";
                        }
                        result.push(this.default_serializer(prop, key));
                    }
                }
            }
            else {
                if (this.is_not_nullable(value)) {
                    result.push(encodeURIComponent(prefix) + "=" + encodeURIComponent("" + value));
                }
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) || result === false ? "" : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {};
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            const query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters, } = this.partition_parameters(parts, required_params, default_options, args);
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (keyword_parameters.trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            result += keyword_parameters.anchor
                ? "#" + keyword_parameters.anchor
                : "";
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            return segment.replace(UriEncoderSegmentRegex, (str) => encodeURIComponent(str));
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return "(" + this.build_path_spec(route[1]) + ")";
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return false
                ? result
                : encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBroswer && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBroswer && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBroswer && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        namespace(object, namespace, routes) {
            const parts = (namespace === null || namespace === void 0 ? void 0 : namespace.split(".")) || [];
            if (parts.length === 0) {
                return routes;
            }
            for (let index = 0; index < parts.length; index++) {
                const part = parts[index];
                if (index < parts.length - 1) {
                    object = object[part] || (object[part] = {});
                }
                else {
                    return (object[part] = routes);
                }
            }
        }
        configure(new_config) {
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
        }
    }
    const Utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return Utils.route(parts_table, route_spec, absolute);
        },
    };
    const result = {
        ...__jsr,
        configure: (config) => {
            return Utils.configure(config);
        },
        config: () => {
            return Utils.config();
        },
        serialize: (object) => {
            return Utils.serialize(object);
        },
        ...{},
    };
    Utils.define_module("ESM", result);
    return result;
})(this);
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

/**
 * Generates rails route to
 * /BI(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const BI_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"BI"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /Bi(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const Bi_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"Bi"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /DevWeek(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const DevWeek_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"DevWeek"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /SUMMIT(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const SUMMIT_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"SUMMIT"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /Summit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const Summit_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"Summit"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /TITV(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const TITV_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"TITV"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /VIP(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const VIP_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"VIP"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/v1/corporate_subscriptions/:id/access_level(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const access_level_api_corporate_subscription_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"corporate_subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"access_level"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_list/unsubscribe/:guid(.:format)
 * @param {any} guid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_list_unsubscribe_path = __jsr.r({"guid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin_list"],[2,[7,"/"],[2,[6,"unsubscribe"],[2,[7,"/"],[2,[3,"guid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin_list/unsubscribe(/:guid)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_list_unsubscribe_post_path = __jsr.r({"guid":{},"format":{}}, [2,[7,"/"],[2,[6,"admin_list"],[2,[7,"/"],[2,[6,"unsubscribe"],[2,[1,[2,[7,"/"],[3,"guid"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /redirect/ad/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const advertisement_redirect_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[6,"ad"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ahoy
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ahoy_engine_path = __jsr.r({}, [2,[7,"/"],[6,"ahoy"]]);

/**
 * Generates rails route to
 * /ahoy/visits(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ahoy_engine_visits_path = __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"ahoy"]],[7,"/"]],[2,[6,"visits"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /ahoy/events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ahoy_engine_events_path = __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"ahoy"]],[7,"/"]],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /ahoy-track/:name(.:format)
 * @param {any} name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ahoy_track_path = __jsr.r({"name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ahoy-track"],[2,[7,"/"],[2,[3,"name"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/ai-chip-makers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_chip_maker_database_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"ai-chip-makers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/ai-chip-makers-data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_chip_maker_database_data_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"ai-chip-makers-data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/ai-data-center-database(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_data_center_database_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"ai-data-center-database"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /subscription/annual-upgrade(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const annual_upgrade_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscription"],[2,[7,"/"],[2,[6,"annual-upgrade"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/articles/slug/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_path = __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[6,"slug"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/stripe/add-payment-method(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_add_payment_method_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"add-payment-method"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/forum_posts/:id/admin_super_pin(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_admin_super_pin_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"forum_posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"admin_super_pin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/forum_posts/:id/admin_toggle_pinned_until(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_admin_toggle_pinned_until_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"forum_posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"admin_toggle_pinned_until"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/forum_posts/:id/admin_update(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_admin_update_forum_post_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"forum_posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"admin_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/affiliate-settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_affiliate_settings_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"affiliate-settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ai_alert_subscriptions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_ai_alert_subscription_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ai_alert_subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ai_alert_subscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_ai_alert_subscriptions_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ai_alert_subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ai_auth/token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_ai_auth_token_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ai_auth"],[2,[7,"/"],[2,[6,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ai_threads/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_ai_thread_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ai_threads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/ai_threads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_ai_threads_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ai_threads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/articles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_article_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/articles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_articles_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"articles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/articles_recommendation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_articles_recommendation_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"articles_recommendation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/autocomplete-entities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_autocomplete_entities_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"autocomplete-entities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/briefings/:identifier(.:format)
 * @param {any} identifier
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_briefing_path = __jsr.r({"identifier":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"briefings"],[2,[7,"/"],[2,[3,"identifier"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/briefings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_briefings_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"briefings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/calendar_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_calendar_events_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"calendar_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/subscription/cancel-past-due(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_cancel_previous_subscription_for_past_due_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"subscription"],[2,[7,"/"],[2,[6,"cancel-past-due"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/group_subscriptions/cancel-team-subscription(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_cancel_team_subscription_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"group_subscriptions"],[2,[7,"/"],[2,[6,"cancel-team-subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/likers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_comment_likers_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"likers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_comments_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/corporate_subscriptions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_corporate_subscription_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"corporate_subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/corporate_subscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_corporate_subscriptions_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"corporate_subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_create_account_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_create_comment_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/corporate-lead(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_create_corporate_lead_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"corporate-lead"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/entities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_create_entity_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"entities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/forum_posts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_create_forum_post_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"forum_posts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/stripe/create-free-subscription(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_create_free_subscription_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"create-free-subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/group_subscriptions/gift(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_create_gift_subscription_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"group_subscriptions"],[2,[7,"/"],[2,[6,"gift"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/landing-page(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_create_landing_page_lead_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"landing-page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/messages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_create_message_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/stripe/create-payment-intent(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_create_payment_intent_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"create-payment-intent"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/stripe/create-setup-intent(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_create_setup_intent_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"create-setup-intent"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/stripe/create-subscription(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_create_subscription_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"create-subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/teams(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_create_team_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"teams"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/group_subscriptions/team-subscription(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_create_team_subscription_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"group_subscriptions"],[2,[7,"/"],[2,[6,"team-subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/group_subscriptions/team-subscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_create_team_subscriptions_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"group_subscriptions"],[2,[7,"/"],[2,[6,"team-subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/veriff/create-session(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_create_veriff_session_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"veriff"],[2,[7,"/"],[2,[6,"create-session"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/stripe/customer-info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_customer_info_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"customer-info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/forum_posts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_delete_forum_post_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"forum_posts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/subscriber_directory/filter_options(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_directory_filter_options_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"subscriber_directory"],[2,[7,"/"],[2,[6,"filter_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/edit/profile(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_edit_profile_settings_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[6,"profile"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/email-settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_email_settings_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"email-settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/group_subscriptions/validate-email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_email_validation_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"group_subscriptions"],[2,[7,"/"],[2,[6,"validate-email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/stripe/estimate-tax-calculation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_estimate_tax_calculation_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"estimate-tax-calculation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/feed/factset(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_feed_factset_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"feed"],[2,[7,"/"],[2,[6,"factset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/feed/test(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_feed_test_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"feed"],[2,[7,"/"],[2,[6,"test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/veriff/fetch-decision(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_fetch_veriff_decision_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"veriff"],[2,[7,"/"],[2,[6,"fetch-decision"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/follow-status/:username(.:format)
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_follower_status_path = __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"follow-status"],[2,[7,"/"],[2,[3,"username"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/forum_posts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_forum_post_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"forum_posts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/forum_posts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_forum_posts_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"forum_posts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/free-pro-trial(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_free_pro_trial_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"free-pro-trial"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/gift-payment-confirmation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_gift_payment_confirmation_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"gift-payment-confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/gift-subscription-settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_gift_subscription_settings_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"gift-subscription-settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/graphics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_graphics_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"graphics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/group_admins/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_group_admin_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"group_admins"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/group_admins(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_group_admins_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"group_admins"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/group_subscriptions/confirmation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_group_subscriptions_confirmation_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"group_subscriptions"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/group_subscriptions/recipients(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_group_subscriptions_recipients_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"group_subscriptions"],[2,[7,"/"],[2,[6,"recipients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/user_onboarding/increment_attempt(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_increment_user_onboarding_attempt_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"user_onboarding"],[2,[7,"/"],[2,[6,"increment_attempt"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/langchain/feedback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_langchain_feedback_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"langchain"],[2,[7,"/"],[2,[6,"feedback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/directory-filter-options(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_legacy_directory_filter_options_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"directory-filter-options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/more_comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_legacy_more_comments_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"more_comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/more_follows(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_legacy_more_follows_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"more_follows"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/show/:username(.:format)
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_legacy_show_subscriber_path = __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"show"],[2,[7,"/"],[2,[3,"username"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/comments/:comment_id/like(.:format)
 * @param {any} comment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_like_comment_path = __jsr.r({"comment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"comment_id"],[2,[7,"/"],[2,[6,"like"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_login_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_login_link_only_status_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/user_onboarding_tooltip/mark_seen(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_mark_user_onboarding_tooltip_seen_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"user_onboarding_tooltip"],[2,[7,"/"],[2,[6,"mark_seen"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/mentionable_users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_mentionable_users_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"mentionable_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/subscriber_directory/more_follows(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_more_follows_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"subscriber_directory"],[2,[7,"/"],[2,[6,"more_follows"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/newsletters/details(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_newsletter_details_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"newsletters"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/newsletters/:newsletter_id/subscribe(.:format)
 * @param {any} newsletter_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_newsletter_subscribe_path = __jsr.r({"newsletter_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"newsletters"],[2,[7,"/"],[2,[3,"newsletter_id"],[2,[7,"/"],[2,[6,"subscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/newsletters/newsletter-subscription-status/:newsletter_id(.:format)
 * @param {any} newsletter_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_newsletter_subscription_status_path = __jsr.r({"newsletter_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"newsletters"],[2,[7,"/"],[2,[6,"newsletter-subscription-status"],[2,[7,"/"],[2,[3,"newsletter_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/newsletters/:newsletter_id/unsubscribe(.:format)
 * @param {any} newsletter_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_newsletter_unsubscribe_path = __jsr.r({"newsletter_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"newsletters"],[2,[7,"/"],[2,[3,"newsletter_id"],[2,[7,"/"],[2,[6,"unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/newsletters(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_newsletters_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"newsletters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/offer(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_offer_info_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"offer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/org_charts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_org_chart_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"org_charts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/org_charts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_org_charts_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"org_charts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/organization/users/active(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_active_users_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"organization"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"active"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/organization/analytics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_analytics_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"organization"],[2,[7,"/"],[2,[6,"analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/organization/users/archived(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_archived_users_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"organization"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"archived"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/organization/details(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_organization_details_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"organization"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/password_reset(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_password_reset_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password_reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/payment-info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_payment_info_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"payment-info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/stripe/payment-methods-list(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_payment_methods_list_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"payment-methods-list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/feed/post/8(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_post_news_path = __jsr.r({"format":{"d":"rss"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"feed"],[2,[7,"/"],[2,[6,"post"],[2,[7,"/"],[2,[6,"8"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/stripe/prepare-invoice-payment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_prepare_invoice_payment_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"prepare-invoice-payment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/profile_settings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_profile_setting_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"profile_settings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/projects/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_project_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/projects(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_projects_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api_react/v1/ai_cohort_notifications_users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_react_v1_ai_cohort_notifications_users_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api_react"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"ai_cohort_notifications_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api_react/v1/user-confirm-action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_react_v1_confirm_action_via_email_code_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api_react"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"user-confirm-action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api_react/v1/marketing-modals/create-or-update(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_react_v1_create_or_update_external_marketing_modal_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api_react"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"marketing-modals"],[2,[7,"/"],[2,[6,"create-or-update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api_react/v1/sessions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_react_v1_create_session_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api_react"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api_react/v1/user-info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_react_v1_current_user_info_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api_react"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"user-info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api_react/v1/events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_react_v1_events_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api_react"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api_react/v1/charts/related/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_react_v1_graphics_related_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api_react"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"charts"],[2,[7,"/"],[2,[6,"related"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api_react/v1/charts/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_react_v1_graphics_search_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api_react"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"charts"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api_react/v1/charts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_react_v1_graphics_show_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api_react"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"charts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api_react/v1/init-user-confirm-action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_react_v1_init_confirm_action_via_email_code_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api_react"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"init-user-confirm-action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api_react/v1/insights(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_react_v1_insights_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api_react"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"insights"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api_react/v1/login-by-email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_react_v1_login_by_email_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api_react"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"login-by-email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api_react/v1/powerlist/:type(.:format)
 * @param {any} type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_react_v1_powerlist_path = __jsr.r({"type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api_react"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"powerlist"],[2,[7,"/"],[2,[3,"type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api_react/v1/powerlist-header/:type(.:format)
 * @param {any} type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_react_v1_powerlist_header_path = __jsr.r({"type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api_react"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"powerlist-header"],[2,[7,"/"],[2,[3,"type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api_react/v1/titv/past-events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_react_v1_titv_past_events_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api_react"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"titv"],[2,[7,"/"],[2,[6,"past-events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api_react/v1/universal/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_react_v1_universal_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api_react"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"universal"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api_react/v1/universal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_react_v1_universal_index_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api_react"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"universal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api_react/v1/user-exist(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_react_v1_user_exist_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api_react"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"user-exist"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/newsletters/recommended(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_recommended_newsletters_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"newsletters"],[2,[7,"/"],[2,[6,"recommended"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/projects/recommended(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_recommended_projects_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"recommended"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/reporters/recommended(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_recommended_reporters_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"reporters"],[2,[7,"/"],[2,[6,"recommended"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/teams/refresh_guid(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_refresh_team_guid_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"refresh_guid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/stripe/remove-payment-method(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_remove_payment_method_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"remove-payment-method"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/comments/:comment_id/report(.:format)
 * @param {any} comment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_report_comment_path = __jsr.r({"comment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"comment_id"],[2,[7,"/"],[2,[6,"report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/subscriber_directory/reporters/lookup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_reporters_lookup_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"subscriber_directory"],[2,[7,"/"],[2,[6,"reporters"],[2,[7,"/"],[2,[6,"lookup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/subscription/resume-paused(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_resume_paused_subscription_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"subscription"],[2,[7,"/"],[2,[6,"resume-paused"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_search_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/search/entities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_search_entities_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"entities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/send_login_link(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_send_login_link_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"send_login_link"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/set-flash-msg(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_set_flash_message_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"set-flash-msg"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/show-confirmation-modal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_show_confirmation_modal_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"show-confirmation-modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/subscriber_directory/show/:username(.:format)
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_show_subscriber_path = __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"subscriber_directory"],[2,[7,"/"],[2,[6,"show"],[2,[7,"/"],[2,[3,"username"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/sign-up-for-weekly-digest(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_sign_up_for_weekly_digest_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"sign-up-for-weekly-digest"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/signup-user(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_signup_user_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"signup-user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/snippets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_snippets_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"snippets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/newsletters/subscribe-to-all-newsletters(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_subscribe_to_all_newsletters_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"newsletters"],[2,[7,"/"],[2,[6,"subscribe-to-all-newsletters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/subscriber_directory/comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_subscriber_comments_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"subscriber_directory"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/subscriber_directory/list(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_subscriber_directory_index_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"subscriber_directory"],[2,[7,"/"],[2,[6,"list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/subscriber_directory(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_subscriber_directory_legacy_index_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"subscriber_directory"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/subscription-status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_subscription_status_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"subscription-status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/suggested_ai_prompts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_suggested_ai_prompts_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"suggested_ai_prompts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/stripe/tax-calculation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_tax_calculation_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"tax-calculation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/teams/current(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_team_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"current"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/titv/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_titv_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"titv"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/titv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_titv_index_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"titv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/top_entities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_top_entities_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"top_entities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/comments/:comment_id/unlike(.:format)
 * @param {any} comment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_unlike_comment_path = __jsr.r({"comment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"comment_id"],[2,[7,"/"],[2,[6,"unlike"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/unsubscribe-from-weekly-digest(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_unsubscribe_from_weekly_digest_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"unsubscribe-from-weekly-digest"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/update-affiliate-settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_update_affiliate_settings_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"update-affiliate-settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/comments/:comment_id(.:format)
 * @param {any} comment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_update_comment_path = __jsr.r({"comment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"comment_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/customerio/device_id(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_update_device_id_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"customerio"],[2,[7,"/"],[2,[6,"device_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/update-email-settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_update_email_settings_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"update-email-settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/follow-entity/:entity_id(.:format)
 * @param {any} entity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_update_follow_entity_path = __jsr.r({"entity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"follow-entity"],[2,[7,"/"],[2,[3,"entity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/follow-identity/:identity_id(.:format)
 * @param {any} identity_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_update_follow_identity_path = __jsr.r({"identity_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"follow-identity"],[2,[7,"/"],[2,[3,"identity_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/forum_posts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_update_forum_post_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"forum_posts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/group_subscriptions/recipients/:recipient_id(.:format)
 * @param {any} recipient_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_update_group_subsciption_path = __jsr.r({"recipient_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"group_subscriptions"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[3,"recipient_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/stripe/update-payment-method(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_update_payment_method_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"update-payment-method"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/stripe/update-default-payment-method(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_update_payment_method_to_default_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"update-default-payment-method"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/profile(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_update_profile_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"profile"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/stripe/update-stripe-customer(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_update_stripe_customer_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"update-stripe-customer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/subscription/update-cbpt(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_update_subscription_for_cbpt_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"subscription"],[2,[7,"/"],[2,[6,"update-cbpt"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/teams(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_update_team_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"teams"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/user_onboarding(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_update_user_onboarding_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"user_onboarding"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/user-account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_user_account_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"user-account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/me/attributes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_user_attributes_update_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"me"],[2,[7,"/"],[2,[6,"attributes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/me(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_user_delete_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"me"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/me(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_user_info_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"me"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/user_onboarding(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_user_onboarding_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"user_onboarding"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/user_recommended_articles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_user_recommended_articles_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"user_recommended_articles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/users/me(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_user_update_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"me"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/group_subscriptions/validate-gift-recipient(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_validate_gift_recipient_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"group_subscriptions"],[2,[7,"/"],[2,[6,"validate-gift-recipient"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/validate-signup-email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_validate_signup_email_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"validate-signup-email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/settings/check-username(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_validate_username_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"check-username"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/verify-cloudflare-turnstile-token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_verify_cloudflare_turnstile_token_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"verify-cloudflare-turnstile-token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/verify-recaptcha-token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_verify_recaptcha_token_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"verify-recaptcha-token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /app(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const app_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"app"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /.well-known/apple-app-site-association(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apple_app_site_association_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[8,"."],[2,[6,"well-known"],[2,[7,"/"],[2,[6,"apple-app-site-association"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /subscription/apply-mou(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apply_mou_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscription"],[2,[7,"/"],[2,[6,"apply-mou"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /articles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const article_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /articles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const articles_feed_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"articles"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /articles/introducing-young-professional-and-all-access-plans(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const articles_introducing_young_professional_and_all_access_plans_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[6,"introducing-young-professional-and-all-access-plans"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /articles/the-besties-revenge-how-the-all-in-podcast-captured-silicon-valley(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const articles_the_besties_revenge_how_the_all_in_podcast_captured_silicon_valley_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[6,"the-besties-revenge-how-the-all-in-podcast-captured-silicon-valley"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /lp/asia-tech-coverage(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const asia_tech_coverage_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lp"],[2,[7,"/"],[2,[6,"asia-tech-coverage"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /assets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const asset_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /.well-known/assetlinks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assetlinks_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[8,"."],[2,[6,"well-known"],[2,[7,"/"],[2,[6,"assetlinks"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /auth/failure(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_failure_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"failure"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /awscomms_feed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const awscomms_feed_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"awscomms_feed"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /bi(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bi_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"bi"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /projects/big-tech-probe(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const big_tech_probe_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"big-tech-probe"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/big-tech-probe-json(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const big_tech_probe_json_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"big-tech-probe-json"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /big-tech-probe-json(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const big_tech_probe_json_redirect_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"big-tech-probe-json"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /big-tech-probe(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const big_tech_probe_redirect_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"big-tech-probe"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /bloomberg_feed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bloomberg_feed_path = __jsr.r({"format":{"d":"atom"}}, [2,[7,"/"],[2,[6,"bloomberg_feed"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /read-us-first(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const brand_campaign_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"read-us-first"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /briefings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const briefing_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"briefings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /briefings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const briefing_feed_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"briefings"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /briefing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const briefing_newsletter_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"briefing"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /cancel-benefits(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_benefits_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cancel-benefits"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /cancel-confirmation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_confirmation_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cancel-confirmation"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /cancel-content(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_content_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cancel-content"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /cancel-feedback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_feedback_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cancel-feedback"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /cancel-feedback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_feedback_post_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cancel-feedback"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /cancel-freeze(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_freeze_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cancel-freeze"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /cancel-offer(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_offer_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cancel-offer"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /cancel-pause(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_pause_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cancel-pause"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /cancel-quality(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_quality_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cancel-quality"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /cancel-time(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_time_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cancel-time"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /china(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const china_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"china"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /china-newsletter(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const china_newsletter_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"china-newsletter"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /citadel_feed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const citadel_feed_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"citadel_feed"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /projects/cloud-database(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cloud_database_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"cloud-database"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/cloud-database-data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cloud_database_data_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"cloud-database-data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /cloud-database-data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cloud_database_data_redirect_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cloud-database-data"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /cloud-database(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cloud_database_redirect_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cloud-database"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /combined_article_briefing_feed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const combined_article_briefing_feed_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"combined_article_briefing_feed"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /combined_feed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const combined_feed_path = __jsr.r({"format":{"d":"atom"}}, [2,[7,"/"],[2,[6,"combined_feed"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /combined_nl_briefing_feed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const combined_nl_briefing_feed_path = __jsr.r({"format":{"d":"atom"}}, [2,[7,"/"],[2,[6,"combined_nl_briefing_feed"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /community/comments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const community_comment_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"community"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /community/comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const community_comments_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"community"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /companies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company-landing/:company(.:format)
 * @param {any} company
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_landing_path = __jsr.r({"company":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company-landing"],[2,[7,"/"],[2,[3,"company"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /subscribe/confirm-subscriber-email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_subscriber_email_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscribe"],[2,[7,"/"],[2,[6,"confirm-subscriber-email"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /contributors/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contributor_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"contributors"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /contributors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contributors_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"contributors"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /projects/corporate-governance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_governance_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"corporate-governance"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /corporate-governance/email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_governance_email_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"corporate-governance"],[2,[7,"/"],[2,[6,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /corporate-governance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_governance_redirect_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"corporate-governance"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /corporate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_landing_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"corporate"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /corporate-sub-read-article-data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const corporate_sub_read_article_data_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"corporate-sub-read-article-data"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /covid19(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const covid19_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"covid19"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /covid-19(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const covid_19_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"covid-19"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /projects/creator-economy-database(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_company_index_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"creator-economy-database"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /create_lead_with_oauth(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_lead_with_oauth_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"create_lead_with_oauth"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /newsletters/:name/unsubscribe(.:format)
 * @param {any} name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_newsletter_unsubscribe_path = __jsr.r({"name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"newsletters"],[2,[7,"/"],[2,[3,"name"],[2,[7,"/"],[2,[6,"unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /events/:slug/create_rsvp(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_rsvp_path = __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"create_rsvp"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /sessions/create_with_oauth(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_session_with_oauth_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[6,"create_with_oauth"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_user_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /creator-economy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const creator_economy_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"creator-economy"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /creator-economy-data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const creator_economy_data_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"creator-economy-data"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /projects/creator-economy-data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const creator_economy_data_json_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"creator-economy-data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /creator-economy-database(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const creator_economy_database_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"creator-economy-database"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /projects/creator-economy-startup-acquisition-targets-data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const creator_startup_takeover_data_json_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"creator-economy-startup-acquisition-targets-data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/creator-economy-startup-acquisition-targets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const creator_startup_takeover_database_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"creator-economy-startup-acquisition-targets"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /creatoreconomy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const creatoreconomy_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"creatoreconomy"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /projects/crypto-powerlist(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const crypto_powerlist_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"crypto-powerlist"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /crypto-powerlist(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const crypto_powerlist_redirect_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"crypto-powerlist"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/v1/corporate_subscriptions/:id/deactivate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deactivate_api_corporate_subscription_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"corporate_subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"deactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /deep_archives(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deep_archives_path = __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"deep_archives"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /deep-research(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deep_research_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"deep-research"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /deep-research/settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deep_research_settings_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"deep-research"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /deep-research/unsubscribe(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deep_research_unsubscribe_get_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"deep-research"],[2,[7,"/"],[2,[6,"unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /deep-research/settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deep_research_unsubscribe_post_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"deep-research"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /devweek(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const devweek_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"devweek"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /upgrade/promotion(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discounted_upgrade_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"upgrade"],[2,[7,"/"],[2,[6,"promotion"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /subscription/downgrade(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downgrade_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscription"],[2,[7,"/"],[2,[6,"downgrade"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/download-csv/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_project_csv_path = __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"download-csv"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/affiliate-settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_affiliate_settings_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"affiliate-settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /community/comments/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_community_comment_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"community"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /forum/posts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_forum_post_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"forum"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /media/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_media_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /passwords/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_password_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"passwords"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/profile(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_profile_settings_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"profile"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_settings_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/topics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_topics_settings_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"topics"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/email-preferences(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_email_settings_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"email-preferences"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/privacy-settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_privacy_settings_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"privacy-settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/team-settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_team_settings_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"team-settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /email-confirmation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_confirmation_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email-confirmation"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /settings/email_verify(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_verification_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"email_verify"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/enterprise-tech-power-list-2022(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprise_powerlist_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"enterprise-tech-power-list-2022"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/enterprise-tech-power-list(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprise_powerlist_2023_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"enterprise-tech-power-list"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /enterprise-tech-power-list(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprise_tech_power_list_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"enterprise-tech-power-list"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /events/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const event_path = __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /events/:slug/info(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const event_info_path = __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const events_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /events/bridging-the-divide-platforms-and-smbs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const events_bridging_the_divide_platforms_and_smbs_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"bridging-the-divide-platforms-and-smbs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /exclusive-article-data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exclusive_article_data_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"exclusive-article-data"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /exclusive-articles-text(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exclusive_articles_text_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"exclusive-articles-text"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /feed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const feed_path = __jsr.r({"format":{"d":"atom"}}, [2,[7,"/"],[2,[6,"feed"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /finance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const finance_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"finance"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /lp/financial-coverage(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const financial_coverage_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lp"],[2,[7,"/"],[2,[6,"financial-coverage"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/follow-newsletter(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const follow_newsletter_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"follow-newsletter"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /for-you(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const for_you_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"for-you"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /highlights(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const for_you_landing_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"highlights"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /forum(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const forum_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"forum"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /forum/:filter(.:format)
 * @param {any} filter
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const forum_filter_path = __jsr.r({"filter":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"forum"],[2,[7,"/"],[2,[3,"filter"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /forum/posts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const forum_post_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"forum"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lp/free-pro-trial(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const free_pro_trial_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lp"],[2,[7,"/"],[2,[6,"free-pro-trial"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /subscription/freeze-rate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const freeze_rate_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscription"],[2,[7,"/"],[2,[6,"freeze-rate"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/future-list-2015(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const future_list_2015_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"future-list-2015"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /future-list-2015(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const future_list_2015_redirect_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"future-list-2015"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /projects/future-list-2016(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const future_list_2016_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"future-list-2016"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /future-list-2016(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const future_list_2016_redirect_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"future-list-2016"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /future-list/email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const future_list_email_redirect_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"future-list"],[2,[7,"/"],[2,[6,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /gift(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gift_landing_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"gift"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /gift-payment-confirmation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gift_payment_confirmation_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"gift-payment-confirmation"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /gifts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gifts_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"gifts"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /projects/gigafactory-database(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gigafactory_database_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gigafactory-database"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/gigafactory-database-data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gigafactory_database_data_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"gigafactory-database-data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /gigafactory-database-data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gigafactory_database_data_redirect_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"gigafactory-database-data"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /gigafactory-database(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gigafactory_database_redirect_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"gigafactory-database"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /go/4146dbb37f(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const go_4146dbb37f_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"go"],[2,[7,"/"],[2,[6,"4146dbb37f"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /.well-known/gpc(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gpc_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[8,"."],[2,[6,"well-known"],[2,[7,"/"],[2,[6,"gpc"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /charts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const graphics_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"charts"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /charts/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const graphics_show_path = __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"charts"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/gift-subscription(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const group_subscriptions_settings_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"gift-subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /health_check(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const health_check_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"health_check"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /help(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /features/:highlight(.:format)
 * @param {any} highlight
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const highlight_path = __jsr.r({"highlight":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"features"],[2,[7,"/"],[2,[3,"highlight"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /top-tech-companies-to-hire-from(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hiring_talent_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"top-tech-companies-to-hire-from"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /home(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const home_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"home"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /calendar-events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ics_event_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"calendar-events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /identity_auth(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const identity_auth_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"identity_auth"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /index_now(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const index_now_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"index_now"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /insider-list(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const insiders_list_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"insider-list"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /insights(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const insights_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"insights"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /projects/leading-from-within(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const intel_survey_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"leading-from-within"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /invalid_link(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invalid_link_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"invalid_link"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /projects/kids-tech-survey(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kids_tech_survey_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"kids-tech-survey"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /kids-tech-survey(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kids_tech_survey_redirect_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"kids-tech-survey"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /lp/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const landing_page_path = __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lp"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /leading-from-within(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leading_from_within_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"leading-from-within"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /feed/:topic(.:format)
 * @param {any} topic
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const legacy_topic_pagination_path = __jsr.r({"topic":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"feed"],[2,[7,"/"],[2,[3,"topic"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /community/comments/:id/like(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const like_community_comment_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"community"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"like"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /login_by_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const login_by_email_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"login_by_email"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /login/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const login_by_link_path = __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"login"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /logout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logout_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /subscription/manage-app-subscription(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manage_app_subscription_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscription"],[2,[7,"/"],[2,[6,"manage-app-subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /media/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const media_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /media(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const media_index_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"media"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /minds(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const minds_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"minds"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /subscription/monthly-lock(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const monthly_lock_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscription"],[2,[7,"/"],[2,[6,"monthly-lock"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/new-financial-power-brokers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_financial_power_brokers_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"new-financial-power-brokers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /new-financial-power-brokers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_financial_power_brokers_redirect_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"new-financial-power-brokers"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /forum/posts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_forum_post_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"forum"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /media/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_media_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /password_reset/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_password_reset_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"password_reset"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sessions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_session_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /newsletter(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newsletter_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"newsletter"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /newsletters/:highlight/archive(.:format)
 * @param {any} highlight
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newsletter_archive_path = __jsr.r({"highlight":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"newsletters"],[2,[7,"/"],[2,[3,"highlight"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /newsletters/:highlight/archive/:slug(.:format)
 * @param {any} highlight
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newsletter_archived_issue_path = __jsr.r({"highlight":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"newsletters"],[2,[7,"/"],[2,[3,"highlight"],[2,[7,"/"],[2,[6,"archive"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /newsletters/:name/:slug(.:format)
 * @param {any} name
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newsletter_article_path = __jsr.r({"name":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"newsletters"],[2,[7,"/"],[2,[3,"name"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /newsletters/:name(.:format)
 * @param {any} name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newsletter_landing_path = __jsr.r({"name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"newsletters"],[2,[7,"/"],[2,[3,"name"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /newsletter-signup/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newsletter_landing_signup_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"newsletter-signup"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /newsletters(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newsletter_list_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"newsletters"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /newsletters/:name/unsubscribe(.:format)
 * @param {any} name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newsletter_one_click_unsubscribe_path = __jsr.r({"name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"newsletters"],[2,[7,"/"],[2,[3,"name"],[2,[7,"/"],[2,[6,"unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /newsletter-paid-subscription(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newsletter_paid_subscription_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"newsletter-paid-subscription"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /newsletter-post-signup(/:id)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newsletter_post_signup_path = __jsr.r({"id":{},"format":{}}, [2,[7,"/"],[2,[6,"newsletter-post-signup"],[2,[1,[2,[7,"/"],[3,"id"]]],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /newsletter-unsubscribe(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newsletter_unsubscribe_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"newsletter-unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /newsletters/:name/unsubscribe-internal(.:format)
 * @param {any} name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newsletter_unsubscribe_internal_path = __jsr.r({"name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"newsletters"],[2,[7,"/"],[2,[3,"name"],[2,[7,"/"],[2,[6,"unsubscribe-internal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /newsletters/the-weekend(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newsletters_the_weekend_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"newsletters"],[2,[7,"/"],[2,[6,"the-weekend"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/general-partners-venture-firms-2024(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const next_gps_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"general-partners-venture-firms-2024"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /nytstory(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const nytstory_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"nytstory"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /nytstory1(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const nytstory1_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"nytstory1"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /omniauth/:provider(.:format)
 * @param {any} provider
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const omniauth_path = __jsr.r({"provider":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"omniauth"],[2,[7,"/"],[2,[3,"provider"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /opinion(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const opinion_feed_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"opinion"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /org-charts/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const org_chart_path = __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org-charts"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /org-charts/:slug/csv-download(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const org_chart_csv_download_path = __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"org-charts"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"csv-download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /org-charts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const org_charts_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"org-charts"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /org-signup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const org_signup_landing_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"org-signup"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /organization/account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_account_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"organization"],[2,[7,"/"],[2,[6,"account"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /organization/registration/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const organization_registration_path = __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organization"],[2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /*slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const page_template_path = __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"slug"]],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /partners(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const partners_list_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"partners"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /passwords/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const password_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"passwords"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /password_reset(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const password_reset_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"password_reset"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /subscription/pause(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pause_subscription_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscription"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /payment-status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payment_status_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"payment-status"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/v1/articles/:id/paywall_params(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paywall_params_api_article_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"paywall_params"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /share/personal-briefing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const personal_briefing_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"share"],[2,[7,"/"],[2,[6,"personal-briefing"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /popular-article-data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const popular_article_data_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"popular-article-data"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /popular-articles-text(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const popular_articles_text_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"popular-articles-text"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /pro(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pro_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pro"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /pro/cluster/:cluster(.:format)
 * @param {any} cluster
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pro_cluster_path = __jsr.r({"cluster":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pro"],[2,[7,"/"],[2,[6,"cluster"],[2,[7,"/"],[2,[3,"cluster"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_path = __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_info_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/info/properties(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_info_properties_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[2,[7,"/"],[2,[6,"properties"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/info/routes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_info_routes_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[2,[7,"/"],[2,[6,"routes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/mailers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mailers_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"mailers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/corporate_subscriptions/:id/reactivate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reactivate_api_corporate_subscription_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"corporate_subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reality-check(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reality_check_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reality-check"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /realitycheck(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const realitycheck_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"realitycheck"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rebound(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rebound_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rebound"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /subscription/receipts/:id/:token(.:format)
 * @param {any} id
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const receipt_show_path = __jsr.r({"id":{"r":true},"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscription"],[2,[7,"/"],[2,[6,"receipts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /subscription/receipts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const receipts_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscription"],[2,[7,"/"],[2,[6,"receipts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/org_charts/recently_updated(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recently_updated_api_org_charts_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"org_charts"],[2,[7,"/"],[2,[6,"recently_updated"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /redirect/apple_sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const redirect_apple_sign_in_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[6,"apple_sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /referrals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const referrals_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"referrals"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /renewal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const renewal_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"renewal"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /renewal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const renewal_post_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"renewal"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /community/comments/:id/report(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const report_community_comment_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"community"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reporters/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reporter_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reporters"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /subscription/resume(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resume_subscription_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscription"],[2,[7,"/"],[2,[6,"resume"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root_path = __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /scoops(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scoops_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"scoops"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_page_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /referrals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_referral_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"referrals"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /settings/unfollow-newsletter(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_unfollow_newsletter_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"unfollow-newsletter"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/v1/articles/:id/share_url(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const share_url_api_article_path = __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"share_url"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /sig_trading_feed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sig_trading_feed_path = __jsr.r({"format":{"d":"atom"}}, [2,[7,"/"],[2,[6,"sig_trading_feed"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /sitemap-articles(-:id).xml(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sitemap_articles_path = __jsr.r({"id":{},"format":{"d":"xml"}}, [2,[7,"/"],[2,[6,"sitemap-articles"],[2,[1,[2,[6,"-"],[3,"id"]]],[2,[8,"."],[2,[6,"xml"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /sitemap-briefings(-:id).xml(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sitemap_briefings_path = __jsr.r({"id":{},"format":{"d":"xml"}}, [2,[7,"/"],[2,[6,"sitemap-briefings"],[2,[1,[2,[6,"-"],[3,"id"]]],[2,[8,"."],[2,[6,"xml"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /sitemap-events(-:id).xml(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sitemap_events_path = __jsr.r({"id":{},"format":{"d":"xml"}}, [2,[7,"/"],[2,[6,"sitemap-events"],[2,[1,[2,[6,"-"],[3,"id"]]],[2,[8,"."],[2,[6,"xml"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /sitemap-features(-:id).xml(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sitemap_features_path = __jsr.r({"id":{},"format":{"d":"xml"}}, [2,[7,"/"],[2,[6,"sitemap-features"],[2,[1,[2,[6,"-"],[3,"id"]]],[2,[8,"."],[2,[6,"xml"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /sitemap-forum(-:id).xml(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sitemap_forum_path = __jsr.r({"id":{},"format":{"d":"xml"}}, [2,[7,"/"],[2,[6,"sitemap-forum"],[2,[1,[2,[6,"-"],[3,"id"]]],[2,[8,"."],[2,[6,"xml"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /sitemap.xml(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sitemap_index_path = __jsr.r({"format":{"d":"xml"}}, [2,[7,"/"],[2,[6,"sitemap"],[2,[8,"."],[2,[6,"xml"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sitemap-news.xml(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sitemap_news_path = __jsr.r({"format":{"d":"xml"}}, [2,[7,"/"],[2,[6,"sitemap-news"],[2,[8,"."],[2,[6,"xml"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sitemap-newsletters(-:id).xml(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sitemap_newsletters_path = __jsr.r({"id":{},"format":{"d":"xml"}}, [2,[7,"/"],[2,[6,"sitemap-newsletters"],[2,[1,[2,[6,"-"],[3,"id"]]],[2,[8,"."],[2,[6,"xml"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /sitemap-org-charts(-:id).xml(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sitemap_orgcharts_path = __jsr.r({"id":{},"format":{"d":"xml"}}, [2,[7,"/"],[2,[6,"sitemap-org-charts"],[2,[1,[2,[6,"-"],[3,"id"]]],[2,[8,"."],[2,[6,"xml"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /sitemap-other.xml(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sitemap_other_path = __jsr.r({"format":{"d":"xml"}}, [2,[7,"/"],[2,[6,"sitemap-other"],[2,[8,"."],[2,[6,"xml"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sitemap-projects(-:id).xml(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sitemap_projects_path = __jsr.r({"id":{},"format":{"d":"xml"}}, [2,[7,"/"],[2,[6,"sitemap-projects"],[2,[1,[2,[6,"-"],[3,"id"]]],[2,[8,"."],[2,[6,"xml"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /sitemap-scoops.xml(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sitemap_scoops_path = __jsr.r({"format":{"d":"xml"}}, [2,[7,"/"],[2,[6,"sitemap-scoops"],[2,[8,"."],[2,[6,"xml"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sitemap-titv(-:id).xml(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sitemap_titv_path = __jsr.r({"id":{},"format":{"d":"xml"}}, [2,[7,"/"],[2,[6,"sitemap-titv"],[2,[1,[2,[6,"-"],[3,"id"]]],[2,[8,"."],[2,[6,"xml"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /sitemap-topics(-:id).xml(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sitemap_topics_path = __jsr.r({"id":{},"format":{"d":"xml"}}, [2,[7,"/"],[2,[6,"sitemap-topics"],[2,[1,[2,[6,"-"],[3,"id"]]],[2,[8,"."],[2,[6,"xml"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /sitemap-users(-:id).xml(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sitemap_users_path = __jsr.r({"id":{},"format":{"d":"xml"}}, [2,[7,"/"],[2,[6,"sitemap-users"],[2,[1,[2,[6,"-"],[3,"id"]]],[2,[8,"."],[2,[6,"xml"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /sitemap-videos(-:id).xml(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sitemap_videos_path = __jsr.r({"id":{},"format":{"d":"xml"}}, [2,[7,"/"],[2,[6,"sitemap-videos"],[2,[1,[2,[6,"-"],[3,"id"]]],[2,[8,"."],[2,[6,"xml"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /special(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const special_offer_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"special"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /projects/sports-streaming-broadcasting-rights(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sports_streaming_database_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"sports-streaming-broadcasting-rights"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /spp(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spp_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"spp"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /sso/microsoft/auth(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sso_microsoft_auth_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sso"],[2,[7,"/"],[2,[6,"microsoft"],[2,[7,"/"],[2,[6,"auth"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /sso/microsoft/enter(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sso_microsoft_enter_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sso"],[2,[7,"/"],[2,[6,"microsoft"],[2,[7,"/"],[2,[6,"enter"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /accelerator(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const static_accelerator_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"accelerator"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /contact(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const static_contact_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"contact"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const static_events_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /about(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const static_index_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"about"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /ioterms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const static_io_terms_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ioterms"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /jobs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const static_jobs_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /payment-policy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const static_payment_policy_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"payment-policy"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /pressed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const static_pressed_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pressed"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /privacy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const static_privacy_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"privacy"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /team(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const static_team_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"team"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /terms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const static_terms_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"terms"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /tips(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const static_tips_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tips"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /student(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const student_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"student"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /students(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const students_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"students"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /subscribe(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscribe_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscribe"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /subscribe/now(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscribe_now_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscribe"],[2,[7,"/"],[2,[6,"now"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /subscribe/one(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscribe_one_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscribe"],[2,[7,"/"],[2,[6,"one"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /subscribe/payment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscribe_payment_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscribe"],[2,[7,"/"],[2,[6,"payment"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /promotion(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscribe_promotion_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"promotion"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /subscribe/promotion(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscribe_redirect_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscribe"],[2,[7,"/"],[2,[6,"promotion"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /subscribe/referral/:guid(.:format)
 * @param {any} guid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscribe_referral_path = __jsr.r({"guid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscribe"],[2,[7,"/"],[2,[6,"referral"],[2,[7,"/"],[2,[3,"guid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /subscribe_h(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscribe_test_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscribe_h"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /subscribe_t(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscribe_test_t_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscribe_t"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /subscribe-all-newsletter(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscribe_to_all_newsletters_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscribe-all-newsletter"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /welcome-to-the-information(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscribe_welcome_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"welcome-to-the-information"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /directory(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscriber_directories_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"directory"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /subscriber_feed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscriber_feed_path = __jsr.r({"format":{"d":"atom"}}, [2,[7,"/"],[2,[6,"subscriber_feed"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /u/:username(/:post_type/:page)(.:format)
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscriber_profile_path = __jsr.r({"username":{"r":true},"post_type":{},"page":{},"format":{}}, [2,[7,"/"],[2,[6,"u"],[2,[7,"/"],[2,[3,"username"],[2,[1,[2,[7,"/"],[2,[3,"post_type"],[2,[7,"/"],[3,"page"]]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /subscription/do-pro-upgrade(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscription_pro_upgrade_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscription"],[2,[7,"/"],[2,[6,"do-pro-upgrade"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /subscription/yp-upgrade(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscription_yp_upgrade_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscription"],[2,[7,"/"],[2,[6,"yp-upgrade"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /login-email-sent(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const success_login_link_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"login-email-sent"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /summit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const summit_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"summit"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /takeaway(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const takeaway_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"takeaway"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /talk(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const talk_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"talk"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /talk/:slug/calendar(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const talk_calendar_path = __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"talk"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"calendar"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /subscribe/team/:guid(.:format)
 * @param {any} guid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const team_subscription_path = __jsr.r({"guid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscribe"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[3,"guid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tech(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tech_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tech"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /tech-briefing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tech_briefing_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tech-briefing"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /tech-exports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tech_exports_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tech-exports"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /tech-impact-briefing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tech_impact_briefing_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tech-impact-briefing"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /projects/tech-ipo-tracker(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tech_ipo_tracker_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"tech-ipo-tracker"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tech-ipo-tracker-data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tech_ipo_tracker_data_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tech-ipo-tracker-data"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /tech-ipo-tracker(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tech_ipo_tracker_redirect_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tech-ipo-tracker"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /projects/tech-sentiment-tracker(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tech_sentiment_tracker_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"tech-sentiment-tracker"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /technology(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const technology_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"technology"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /projects/tesla-alumni-companies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tesla_diaspora_database_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"tesla-alumni-companies"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /test(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const test_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"test"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /the-briefing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const the_briefing_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"the-briefing"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /the-electric(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const the_electric_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"the-electric"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /the-information-50(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const the_information_50_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"the-information-50"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /the-information-50-2020(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const the_information_50_2020_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"the-information-50-2020"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /the-information-50-2021(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const the_information_50_2021_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"the-information-50-2021"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /the-information-50-database(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const the_information_50_database_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"the-information-50-database"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /the-information-am(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const the_information_am_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"the-information-am"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /the-takeaway(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const the_takeaway_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"the-takeaway"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /thebriefing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const thebriefing_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"thebriefing"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /theelectric(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const theelectric_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"theelectric"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /ti50(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ti50_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ti50"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /ti50-2020(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ti50_2020_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ti50-2020"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /ti50-2021(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ti50_2021_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ti50-2021"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /projects/the-information-50-database(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ti50_database_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"the-information-50-database"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/ti50-database-data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ti50_database_data_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"ti50-database-data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ti50-database-data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ti50_database_data_redirect_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ti50-database-data"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /projects/the-information-50-2020(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ti_50_list_2020_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"the-information-50-2020"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/the-information-50-2021(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ti_50_list_2021_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"the-information-50-2021"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/the-information-50-2022(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ti_50_list_2022_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"the-information-50-2022"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/the-information-50-2023(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ti_50_list_2023_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"the-information-50-2023"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/the-information-50-2024(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ti_50_list_2024_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"the-information-50-2024"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/the-information-50-2025(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ti_50_list_2025_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"the-information-50-2025"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/the-information-50(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ti_50_list_current_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"the-information-50"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ti-am(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ti_am_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ti-am"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /tiam(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tiam_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tiam"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /titv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const titv_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"titv"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /titv/:guid(.:format)
 * @param {any} guid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const titv_show_path = __jsr.r({"guid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"titv"],[2,[7,"/"],[2,[3,"guid"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /topics(/:topic)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topic_landing_path = __jsr.r({"topic":{},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[1,[2,[7,"/"],[3,"topic"]]],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /deals/20vc(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twenty_vc_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"deals"],[2,[7,"/"],[2,[6,"20vc"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/unfollow-newsletter(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unfollow_newsletter_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"unfollow-newsletter"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /unlock-content(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlock_content_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"unlock-content"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /unlock-content-with-oauth(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlock_content_with_oauth_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"unlock-content-with-oauth"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /unsubscribe(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsubscribe_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /unsubscribe-from-newsletter/:newsletter_id(.:format)
 * @param {any} newsletter_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsubscribe_from_newsletter_path = __jsr.r({"newsletter_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"unsubscribe-from-newsletter"],[2,[7,"/"],[2,[3,"newsletter_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/unsubscribe-from-newsletter(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsubscribe_newsletter_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"unsubscribe-from-newsletter"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /subscription/update-card-cb(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_card_churnbuster_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscription"],[2,[7,"/"],[2,[6,"update-card-cb"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /subscription/update-payment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_payment_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscription"],[2,[7,"/"],[2,[6,"update-payment"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /upgrade(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upgrade_subscription_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"upgrade"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_dashboard_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /*slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vanity_url_path = __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"slug"]],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /projects/vc-cafes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vc_cafes_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"vc-cafes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/vc-cafes-data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vc_cafes_data_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"vc-cafes-data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /vc-cafes-data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vc_cafes_data_redirect_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"vc-cafes-data"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /vc-cafes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vc_cafes_redirect_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"vc-cafes"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /projects/vc-diversity-index(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vc_diversity_index_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"vc-diversity-index"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /projects/vc-diversity-index-2017(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vc_diversity_index_2017_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"vc-diversity-index-2017"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /vc-diversity-index-2017(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vc_diversity_index_2017_redirect_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"vc-diversity-index-2017"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /projects/vc-diversity-index-2018(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vc_diversity_index_2018_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"vc-diversity-index-2018"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /vc-diversity-index-2018(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vc_diversity_index_2018_redirect_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"vc-diversity-index-2018"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /vc-diversity-index(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vc_diversity_index_redirect_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"vc-diversity-index"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /video/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const video_path = __jsr.r({"id":{"r":true},"format":{"d":"html"}}, [2,[7,"/"],[2,[6,"video"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /video/latest(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const video_latest_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"video"],[2,[7,"/"],[2,[6,"latest"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /video(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const video_library_path = __jsr.r({"format":{"d":"html"}}, [2,[7,"/"],[2,[6,"video"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /subscription/pro-upgrade(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const view_pro_upgrade_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscription"],[2,[7,"/"],[2,[6,"pro-upgrade"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /vip(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vip_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"vip"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /webhook/stripe(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhook_stripe_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webhook"],[2,[7,"/"],[2,[6,"stripe"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /webhook/veriff(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhook_veriff_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webhook"],[2,[7,"/"],[2,[6,"veriff"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /webhooks/revenuecat(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooks_revenuecat_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"revenuecat"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /weekend(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weekend_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"weekend"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/v1/group_admins/welcome_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const welcome_email_api_group_admins_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"group_admins"],[2,[7,"/"],[2,[6,"welcome_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /what-we-do(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const what_we_do_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"what-we-do"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /yahoo_finance_feed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yahoo_finance_feed_path = __jsr.r({"format":{"d":"rss"}}, [2,[7,"/"],[2,[6,"yahoo_finance_feed"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /young-professionals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const young_professionals_path = __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"young-professionals"],[1,[2,[8,"."],[3,"format"]]]]]);

